import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Mail, MessageCircle } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | 'contact' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const closeModal = () => setActiveModal(null);
  return <>
      <footer className="bg-[#050505] border-t border-white/5 py-8 px-4" data-id="element-49">
        <div className="max-w-4xl mx-auto text-center space-y-4" data-id="element-50">
          <div className="flex items-center justify-center gap-6 text-sm" data-id="element-51">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-500 hover:text-gamer-red transition-colors font-inter underline-offset-4 hover:underline" data-id="element-52">
              Política de Privacidad
            </button>
            <span className="text-gray-700" data-id="element-53">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-gray-500 hover:text-gamer-red transition-colors font-inter underline-offset-4 hover:underline" data-id="element-54">
              Términos y Condiciones
            </button>
            <span className="text-gray-700" data-id="element-55">|</span>
            <button onClick={() => setActiveModal('contact')} className="text-gray-500 hover:text-gamer-red transition-colors font-inter underline-offset-4 hover:underline" data-id="element-56">
              Contacto
            </button>
          </div>

          <p className="text-gray-600 text-xs font-inter" data-id="element-57">
            © 2024 Dominio Total Free Fire. Todos los derechos reservados.
          </p>
          <p className="text-gray-700 text-xs font-inter max-w-lg mx-auto" data-id="element-58">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-59">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={closeModal} data-id="element-60">
            <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} transition={{
          type: 'spring',
          duration: 0.5
        }} className="bg-[#111111] border border-white/10 rounded-xl w-full max-w-2xl max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-61">
              {/* Modal Header */}
              <div className="flex items-center justify-between p-5 border-b border-white/10" data-id="element-62">
                <h3 className="text-lg font-orbitron font-bold text-white" data-id="element-63">
                  {activeModal === 'privacy' && 'Política de Privacidad'}
                  {activeModal === 'terms' && 'Términos y Condiciones'}
                  {activeModal === 'contact' && 'Información de Contacto'}
                </h3>
                <button onClick={closeModal} className="text-gray-400 hover:text-white transition-colors p-1" data-id="element-64">
                  <X className="w-5 h-5" data-id="element-65" />
                </button>
              </div>

              {/* Modal Content */}
              <div className="p-6 overflow-y-auto max-h-[calc(80vh-70px)] text-gray-300 font-inter text-sm leading-relaxed space-y-4" data-id="element-66">
                {activeModal === 'privacy' && <PrivacyContent data-id="element-67" />}
                {activeModal === 'terms' && <TermsContent data-id="element-68" />}
                {activeModal === 'contact' && <ContactContent data-id="element-69" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-gray-400 text-xs" data-id="element-70">
        Última actualización: Febrero 2026
      </p>

      <h4 className="text-white font-bold text-base mt-4" data-id="element-71">
        1. Información que recopilamos
      </h4>
      <p data-id="element-72">
        Recopilamos información personal que nos proporcionás voluntariamente al
        realizar una compra, incluyendo: nombre, dirección de correo electrónico
        y datos de pago procesados de forma segura por nuestra pasarela de
        pagos.
      </p>

      <h4 className="text-white font-bold text-base" data-id="element-73">
        2. Uso de la información
      </h4>
      <p data-id="element-74">Utilizamos tu información para:</p>
      <ul className="list-disc list-inside space-y-1 text-gray-400" data-id="element-75">
        <li data-id="element-76">Procesar y entregar tu compra digital</li>
        <li data-id="element-77">Enviarte el acceso al producto adquirido</li>
        <li data-id="element-78">Comunicarnos contigo sobre tu pedido</li>
        <li data-id="element-79">Mejorar nuestros productos y servicios</li>
      </ul>

      <h4 className="text-white font-bold text-base" data-id="element-80">3. Protección de datos</h4>
      <p data-id="element-81">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado, alteración
        o destrucción.
      </p>

      <h4 className="text-white font-bold text-base" data-id="element-82">4. Terceros</h4>
      <p data-id="element-83">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros, excepto a proveedores de servicios de pago necesarios para
        procesar tu transacción.
      </p>

      <h4 className="text-white font-bold text-base" data-id="element-84">5. Cookies</h4>
      <p data-id="element-85">
        Utilizamos cookies y tecnologías similares para mejorar tu experiencia
        de navegación y analizar el tráfico del sitio. Podés configurar tu
        navegador para rechazar cookies.
      </p>

      <h4 className="text-white font-bold text-base" data-id="element-86">6. Tus derechos</h4>
      <p data-id="element-87">
        Tenés derecho a acceder, rectificar o eliminar tu información personal
        en cualquier momento contactándonos a través de nuestros canales de
        comunicación.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-gray-400 text-xs" data-id="element-88">
        Última actualización: Febrero 2026
      </p>

      <h4 className="text-white font-bold text-base mt-4" data-id="element-89">
        1. Producto digital
      </h4>
      <p data-id="element-90">
        "Dominio Total en Free Fire" es un producto 100% digital (ebook) que se
        entrega de forma inmediata tras confirmar el pago. El acceso se envía al
        correo electrónico proporcionado durante la compra.
      </p>

      <h4 className="text-white font-bold text-base" data-id="element-91">2. Uso permitido</h4>
      <p data-id="element-92">
        El producto es para uso personal y exclusivo del comprador. Queda
        prohibida la reproducción, distribución, reventa o compartición del
        contenido sin autorización expresa.
      </p>

      <h4 className="text-white font-bold text-base" data-id="element-93">3. Resultados</h4>
      <p data-id="element-94">
        Los resultados mencionados en esta página son ejemplos y pueden variar
        según cada jugador. No garantizamos resultados específicos ya que
        dependen del esfuerzo, dedicación y habilidad individual de cada
        usuario.
      </p>

      <h4 className="text-white font-bold text-base" data-id="element-95">4. Testimonios</h4>
      <p data-id="element-96">
        Los testimonios mostrados representan experiencias individuales de
        usuarios. Los resultados pueden variar y no constituyen una garantía de
        rendimiento.
      </p>

      <h4 className="text-white font-bold text-base" data-id="element-97">5. Pagos y reembolsos</h4>
      <p data-id="element-98">
        Todos los pagos se procesan de forma segura. Dado que el producto es
        digital y se entrega de forma inmediata, no se ofrecen reembolsos una
        vez realizada la descarga o acceso al contenido.
      </p>

      <h4 className="text-white font-bold text-base" data-id="element-99">
        6. Propiedad intelectual
      </h4>
      <p data-id="element-100">
        Todo el contenido del ebook, incluyendo textos, estrategias, gráficos y
        diseño, es propiedad exclusiva de Dominio Total Free Fire y está
        protegido por las leyes de propiedad intelectual.
      </p>

      <h4 className="text-white font-bold text-base" data-id="element-101">7. Disclaimer</h4>
      <p data-id="element-102">
        Este producto no está afiliado, asociado, autorizado, respaldado ni
        conectado de ninguna manera con Garena, Free Fire o cualquiera de sus
        subsidiarias. Los nombres y marcas mencionados son propiedad de sus
        respectivos dueños.
      </p>
    </>;
}
function ContactContent() {
  return <div className="space-y-6" data-id="element-103">
      <p data-id="element-104">
        Si tenés alguna consulta sobre tu compra, el producto o necesitás
        soporte, podés contactarnos a través de los siguientes canales:
      </p>

      <div className="space-y-4" data-id="element-105">
        <div className="flex items-center gap-4 bg-white/5 rounded-lg p-4 border border-white/5" data-id="element-106">
          <div className="p-2 bg-gamer-red/10 rounded-lg" data-id="element-107">
            <Mail className="w-5 h-5 text-gamer-red" data-id="element-108" />
          </div>
          <div data-id="element-109">
            <p className="text-white font-bold text-sm" data-id="element-110">Email</p>
            <p className="text-gray-400" data-id="element-111">soporte@juegospro369.online</p>
          </div>
        </div>

        <div className="flex items-center gap-4 bg-white/5 rounded-lg p-4 border border-white/5" data-id="element-112">
          <div className="p-2 bg-green-500/10 rounded-lg" data-id="element-113">
            <MessageCircle className="w-5 h-5 text-green-500" data-id="element-114" />
          </div>
          <div data-id="element-115">
            <p className="text-white font-bold text-sm" data-id="element-116">WhatsApp</p>
            <p className="text-gray-400" data-id="element-117">Respondemos en menos de 24 horas</p>
          </div>
        </div>
      </div>

      <p className="text-gray-500 text-xs" data-id="element-118">
        Horario de atención: Lunes a Viernes de 9:00 a 18:00 (hora Argentina)
      </p>
    </div>;
}